import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useSearchQuery from '../../../hooks/useSearchQuery';
import matomo from '../../../utils/matomo';

const CancelledSubscriptionRedirectPage = () => {
  const history = useHistory();
  const { redirect } = useSearchQuery();

  useEffect(() => {
    matomo.clickEvent({
      category: 'Boligmappa+',
      action: 'Subscription Successfully Cancelled',
    });
    history.push(`${redirect || ''}/my-purchases?cancelled=true`);
  }, [history]);
  return (
    <div style={{ display: 'none' }}>
      <h1>CancelledSubscription</h1>
    </div>
  );
};

export default CancelledSubscriptionRedirectPage;
